import React from "react";
import "./Navbar.scss";

const NavBar = (props) => {
	return (
		<main>
			<div className="navbar-container">
				<ul>
					<li>
						<a
							href="/"
							className={props.active === "home" ? "is-active" : "is-inactive"}
						>
							HOME
						</a>
					</li>
					<li>
						<a
							className={props.active === "about" ? "is-active" : "is-inactive"}
							href="/about"
						>
							ABOUT ME
						</a>
					</li>
					<li>
						<a
							href="/blog"
							className={props.active === "blog" ? "is-active" : "is-inactive"}
						>
							BLOG
						</a>
					</li>
				</ul>
			</div>
		</main>
	);
};

export default NavBar;
